import { ReactNode } from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { UserRole } from '../types';
import { Loading } from './ui/Loading';

interface ProtectedRouteProps {
  allowed: UserRole[];
  children: ReactNode;
}

const roleRank: Record<UserRole, number> = {
  USER: 1,
  EMPLOYEE: 2,
  ADMIN: 3,
  SUPERADMIN: 4,
};

export const ProtectedRoute = ({ allowed, children }: ProtectedRouteProps) => {
  const { role, status, loading } = useAuth();

  if (loading) return <Loading full />;
  if (!role) return <Navigate to="/login" replace />;
  if (status === 'UNDER_REVIEW') return <Navigate to="/pending-approval" replace />;
  const minRank = Math.min(...allowed.map((r) => roleRank[r]));
  if ((roleRank[role] ?? 0) < minRank) return <Navigate to="/phone-book" replace />;
  return children;
};
